/** @format */
import { Typography } from '@mui/material';
import './style.css';

const LoadingWaveText = ({ text, fontSize = '0.85rem' }) => {
  return (
    <div className="flex justify-center items-center">
      {text.split('').map((char, index) => (
        <Typography
          component="span"
          key={index}
          // Apply animation classes to each character
          className="loading-char text-5xl font-bold text-blue-400 mx-0.5"
          // Calculate animation delay for a wave effect
          sx={{
            fontSize,
            animationDelay: `${index * 0.1}s`,
          }}
        >
          {char === ' ' ? '\u00A0' : char}{' '}
          {/* Handle spaces by using non-breaking space */}
        </Typography>
      ))}
    </div>
  );
};

export default LoadingWaveText;
